import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { Checkbox } from "@/shared/components/check-box/check-box";
import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { useSyncAccounts, AccountsInfo } from "@/features/accounts/shared/hooks/use-sync-accounts";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  passbookType: string;
  accountGroupId: string;
  mlinkAccountId: string;
  mlinkId: string;
  scrapeType: number;
  onTapCompleteModal: (registAccounts: AccountsInfo[]) => void;
  onTapCloseModal: () => void;
}

// 口座追加モーダル(同期処理)
export const SyncAccountsModal = ({ 
  passbookType,
  accountGroupId,
  mlinkAccountId,
  mlinkId,
  scrapeType,
  onTapCompleteModal,
  onTapCloseModal }: Props) => {
  const [list, setList] = useState<AccountsInfo[]>([]);
  const [isListLoading, setIsListLoading] = useState(true);
  const { 
    isActiveRegisterButton,
    setIsActiveRegisterButton,
    onClickSyncAccounts,
    onClickAdd,
    cancelAdd,
  } = useSyncAccounts({onTapCompleteModal});

  useEffect(() => {
    const updateList = async () => {
      setIsListLoading(true);
      try {
        const res = await onClickSyncAccounts(passbookType, accountGroupId, mlinkAccountId, mlinkId, scrapeType);
        if (res === undefined) {
          // 口座情報の取得に失敗
          return;
        }
        const updlist = res.map((item) => ({
          ...item,
          userInputName: `${institutionName} ${item.accountKindName}${serviceType}` +
                          `${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`,
        }));
        setList(updlist);
      } finally {
        setIsListLoading(false);
      }
      };
    updateList();
  }, []);

  // チェックボックスのON/OFF
  const onClickCheck = (index: number) => {
    const updated = [...list];
    updated[index].selectedStatus = updated[index].selectedStatus === 1 ? 0 : 1;
    setList(updated);
  };

  const onChangeAddButtonState = (index: number, value: string) => {
    const updated = [...list];
    updated[index].userInputName = value;
    setList(updated);
  }

  useEffect(() => {
    const updated = [...list];
    // 作成ボタンの活性/非活性制御
    let hasChecked = updated.every((item) => 
      (item.selectedStatus === 1 && item.userInputName.trim() !== "")
      || (item.selectedStatus === 0)
    );
    if (updated.every((item) => item.selectedStatus === 0)) {
      hasChecked = false;
    }
    setIsActiveRegisterButton(hasChecked);
  }, [list]);

  // 作成ボタンに付与するID
  const syncAccountsButton = "sync_accounts_button";

  // 登録時にユーザー入力の値をトリム（前後の空白を削除）してから処理する
  const handleAdd = () => {
    const trimmedList = list.map((item) => ({
      ...item,
      userInputName: item.userInputName?.slice(0, 50).trim() ?? "",
    }));
    onClickAdd(trimmedList);
  };

  // localStorageに保存した名前を取り出す
  const institutionName = localStorage.getItem("institutionName") || "";
  const serviceType = localStorage.getItem("serviceType") || "";

  return (
    <BasePageModal
      title="口座を追加"
      handleClose={() => {
        cancelAdd(list);
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="口座を追加"
          onClick={handleAdd}
          id={syncAccountsButton}
          loadingNegative={true}
          isActive={isActiveRegisterButton}
        />
      }
      className="md-list-add"
      disableOverlayClose={true}
    >
      <h2>連携させる口座をすべて選択してください</h2>
      {isListLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "16px 0" }}>
          <ReactLoading type="spin" color="#4f4f4f" height={28} width={28} />
        </div>
      ) : (
        <ul>
          {list.map((item, index) => (
            <li key={`${item.mlinkAccountId}-${item.mlinkId}`}>
              <Checkbox
                label={`${institutionName} ${item.accountKindName}${serviceType}
                        ${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`}
                id={`account-${index}`}
                checked={item.selectedStatus === 1}
                handleChange={() => {
                  onClickCheck(index)
                }}
              />
              <SimpleForm
                placeholder="Web明細帳名を設定（必須）"
                initialValue={`${institutionName} ${item.accountKindName}${serviceType} `+
                              `${(item.accountNo !== "" && item.accountNo !== undefined) ? " 口座No." + item.accountNo : ""}`}
                //initialValue={item.userInputName}
                onChange={(value) => {
                  onChangeAddButtonState(index, value)
                }}
              />
            </li>
          ))}
        </ul>
      )}
    </BasePageModal>
  );
};
